import { NavigationService } from './../../../core/services/navigation/navigation.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { confirmedValidator } from 'src/app/core/helpers/password-validator';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { CustomValidatorService } from 'src/app/core/services/custom-validator/custom-validator.service';
import { ApiResponse } from 'src/app/core/interfaces/api-response/ApiResponse.interface';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    hide: boolean = true;
    hide2: boolean = true;
    resetPasswordForm: FormGroup;
    AuthenticationRoutes = urlRoutes;
    resetToken!: string;

    constructor(
        public themeService: CustomizerSettingsService,
        private formBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        private activatedRoute: ActivatedRoute,
        private loaderService: LoaderService,
        private toasterService: ToasterService,
        private navigationService: NavigationService,
        private customValidators: CustomValidatorService
    ) {}

    ngOnInit(): void {
        this.initiatechangePwdForm();
        this.initialSubscribers();
    }

    initiatechangePwdForm() {
        this.resetPasswordForm = this.formBuilder.group(
            {
                password: [
                    '',
                    Validators.compose([
                        Validators.required,
                        // this.customValidators.patternValidator(),
                    ]),
                ],
                confirmpassword: [
                    '',
                    Validators.compose([
                        Validators.required,
                        // this.customValidators.patternValidator(),
                    ]),
                ],
            },
            {
                validator: confirmedValidator('password', 'confirmpassword'),
            }
        );
    }

    initialSubscribers(): void {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            if (!params['code']) {
                const redirectRoute = `/${this.AuthenticationRoutes.authentication}/${this.AuthenticationRoutes.login}`;
                this.navigationService.routeToPath(redirectRoute);
                return;
            }
            const token: string = params['code'];
            this.getIsTokenValid(token);
        });
    }

    getIsTokenValid(token: string): void {
        this.loaderService.showLoader();
        this.authenticationService.decodeResetToken(token).subscribe(
            (res: ApiResponse<any>) => {
                this.loaderService.hideLoader();
                this.resetToken = res.data.token;
            },
            (err) => {
                this.loaderService.hideLoader();
                if(true){
                const redirectRoute = `/${this.AuthenticationRoutes.authentication}/${this.AuthenticationRoutes.login}`;
                this.navigationService.routeToPath(redirectRoute);
                }
            }
        );
    }

    resetForm(): void {
        this.resetPasswordForm.reset();
    }

    /* Submit Clicked */
    onSubmit(): void {
        
        if (this.resetPasswordForm.invalid) {
            this.toasterService.showError(
                'Field Issue',
                'Something went wrong! Please enter a valid password!'
            );
            return;
        }
        this.loaderService.showLoader();
        let payload = this.resetPasswordForm.getRawValue();
        payload = {
            ...payload,
            token: this.resetToken,
        };
        this.authenticationService.resetPassword(payload).subscribe(
            () => {
                this.loaderService.hideLoader();
                this.toasterService.showSuccess(
                    'Reset Password',
                    'Password Changed Successfully!'
                );
                const redirectRoute = `/${this.AuthenticationRoutes.authentication}/${this.AuthenticationRoutes.login}`;
                this.navigationService.routeToPath(redirectRoute);
            },
            () => {
                this.loaderService.hideLoader();
            }
        );
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }
}
